/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceDepartmentDetails {
    getFixupPrototypeFunction() { return FreshserviceDepartmentDetails.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceDepartmentDetails>): FreshserviceDepartmentDetails {
        let obj = Object.assign(new FreshserviceDepartmentDetails(), model);
        FreshserviceDepartmentDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceDepartmentDetails>): FreshserviceDepartmentDetails {
        if (!model) return null;
        return FreshserviceDepartmentDetails.newInstance(<FreshserviceDepartmentDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceDepartmentDetails) {
        if (!obj) return;

        models.FreshserviceDepartmentDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceDepartmentDetails): boolean {
        Object.setPrototypeOf(obj, FreshserviceDepartmentDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.department_id === undefined) {
            this.department_id = 0;
        }
    }

    /**
     * Department Id
     */
    department_id: number;

    /**
     * Department Name
     */
    name: string;

}
